module.exports = __webpack_public_path__ + "img/tj.a747c5fc.jpg";